import React from "react";
import { TicketsPage } from "../shared/TicketsPage";
export const DesignTicketsPage: React.FC = () => <TicketsPage design />;
